import { render, staticRenderFns } from "./UserConvertButton.vue?vue&type=template&id=08a7f6bc"
import script from "./UserConvertButton.vue?vue&type=script&lang=js"
export * from "./UserConvertButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports